import axios from "axios";
import { SERVER_URL } from "Constants";

export interface LiquorLicenceDetails {
	source: string;
	uniqueId: string;
	licenceNumber: string;
	interimAuthNumber: string;
	bannerClassId: string;
	bannerClass: string;
	bannerOwnershipId: string;
	bannerOwnership: string;
	bannerId: string;
	banner: string;
	banner2: string;
	bannerDescription: string;
	channelId: string;
	channel: string;
	subChannelId: string;
	subChannel: string;
	channelCategoryId: string;
	channelCategory: string;
	precinct: string;
	tradingName: string;
	tradingNameAd: string;
	addressLine1: string;
	addressLine2: string;
	suburb: string;
	serialState: string;
	postcode: string;
	telephone: string;
	fax: string;
	reportState: string;
	familyName: string;
	givenName: string;
	initials: string;
	howHeld1: string;
	howHeld2: string;
	howHeld3: string;
	howHeld4: string;
	howHeldName: string;
	metropolitanCountry: string;
	status: string;
	grantedDate: Date;
	postalAddress1: string;
	postalAddress2: string;
	postalSuburb: string;
	postalState: string;
	postalPostcode: string;
	email: string;
	active: string;
	longitude: string;
	latitude: string;
	abn: string;
	acn: string;
	rbn: string;
	abnStatus: string;
	abnDate: string;
	gstStatus: string;
	companyStatus: string;
	otdOutletId: string;
	almCode: string;
	cccCode: string;
	ilgCode: string;
	lmxCode: string;
	lsbCode: string;
	parCode: string;
	firstUId: string;
	mal: boolean;
	slid: string;
	dateCreated?: Date;
	dateClosed?: Date;
	dateModified?: Date;
}

export interface LiquorLicenceValidationResponseData {
	licenceDetails: string;
	responseCode: number;
	responseMessage: string;
}

export interface LiquorLicenceValidationResponse {
	data: LiquorLicenceValidationResponseData;
	exception: {
		exceptionDescription: string;
	};
}

export function validateLiquorLicenceNumber(licenceNumber: string, licenceState: string, customerId?: string) {
	return axios.post(`${SERVER_URL}/api/liquor-licence-validation`, {
		licenceNumber,
		state: licenceState,
		customerId: customerId,
	}).then(data => {
		return { data: data.data } as LiquorLicenceValidationResponse;
	}).catch(exception => {
		return { exception: { exceptionDescription: exception.response.data } } as LiquorLicenceValidationResponse;
	});
}
